import type { SocialItem } from '~/types';

export const SOCIAL_ITEMS_FORM: SocialItem[] = [
  { icon: 'facebook', href: RedirectConfig.facebook },
  { icon: 'linkedin', href: RedirectConfig.linkedIn },
  { icon: 'instagram', href: RedirectConfig.instagram },
];

export const APP_LINKS = [
  { href: '#', image: '/images/app-store.svg' },
  { href: '#', image: '/images/google-play.svg' },
];
